export default __webpack_public_path__ + "static/media/wolchapter1.4abfb77b.png";